import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_TABS = CLASS_ASIDE_PANEL + '__tabs';
